import React from "react";
import { Col, Row, Skeleton } from "antd";
import styled from "styled-components";

const OverallGradeRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 3%;
  margin-bottom: 42px;
`;

const OverallGradeLeft = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  min-width: 140px;
`;

const OverallGradeRight = styled.div`
  flex: 1;
  min-width: 0;
  border-radius: 7px;
  padding: 8px 0;
`;

const FilterRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 14px;
  margin-top: 10px;
`;

const FilterFieldSkeleton = styled.div`
  flex: 1;
  min-width: 0;
`;

const TabsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 16px;
`;

const TabsActionsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
`;

const AssignmentListPanel = styled.div`
  filter: drop-shadow(0px 0px 2.54px rgba(0, 0, 0, 0.26));
  background: #fff;
  border-radius: 7px;
  padding: 16px;
`;

const AssignmentRowSkeleton = styled.div`
  padding: 14px 0;
  border-bottom: 1px solid #eef0f6;

  &:last-child {
    border-bottom: none;
  }
`;

const ProgressCardSkeleton = styled.div`
  width: 46%;
  margin-bottom: 27px;
  padding: 15px 20px 28px;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0px 0px 2.54px rgba(0, 0, 0, 0.26);
`;

const CardsGrid = styled.div`
  margin-top: 28px;
  padding-left: 52px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8%;
  align-content: flex-start;
`;

const ASSIGNMENT_SKELETON_COUNT = 6;
const CARD_SKELETON_COUNT = 6;
const TAB_SKELETON_COUNT = 2;

const StudentVisualsSkeleton = () => (
  <Row className="studentVisualsRow">
    <Col xs={{ span: 24 }} lg={{ span: 24 }} xl={{ span: 17 }} style={{ marginBottom: 20 }}>
      <OverallGradeRow className="ovrAllGrade">
        <OverallGradeLeft className="ovrAllGradeCmn ovrAllGradeLeft">
          <Skeleton.Avatar active size={116} shape="circle" />
          <Skeleton.Input active size="small" style={{ width: 180 }} />
        </OverallGradeLeft>
        <OverallGradeRight className="ovrAllGradeCmn ovrAllGradeRght">
          <Skeleton.Input active size="small" style={{ width: 120, marginBottom: 10 }} />
          <FilterRow className="ovrAllGradeDrop">
            {[0, 1, 2].map((index) => (
              <FilterFieldSkeleton key={index}>
                <Skeleton.Input active size="small" style={{ width: 56, marginBottom: 6 }} />
                <Skeleton.Input active block style={{ height: 48, borderRadius: 8 }} />
              </FilterFieldSkeleton>
            ))}
          </FilterRow>
        </OverallGradeRight>
      </OverallGradeRow>

      <TabsRow className="stdntTabsLeft">
        {Array.from({ length: TAB_SKELETON_COUNT }).map((_, index) => (
          <Skeleton.Button
            key={index}
            active
            style={{ width: 180, height: 50, borderRadius: "16px 16px 0 0" }}
          />
        ))}
      </TabsRow>

      <TabsActionsRow className="studentActivityDropdwon">
        <Skeleton.Input active style={{ width: 200, height: 56, borderRadius: 4 }} />
        <Skeleton.Input active style={{ width: 160, height: 24 }} />
      </TabsActionsRow>

      <AssignmentListPanel>
        {Array.from({ length: ASSIGNMENT_SKELETON_COUNT }).map((_, index) => (
          <AssignmentRowSkeleton key={index}>
            <Skeleton
              active
              title={{ width: "45%" }}
              paragraph={{ rows: 2, width: ["70%", "35%"] }}
            />
          </AssignmentRowSkeleton>
        ))}
      </AssignmentListPanel>
    </Col>

    <Col
      xs={{ span: 24 }}
      lg={{ span: 24 }}
      xl={{ span: 7 }}
      className="quizCardSection"
    >
      <CardsGrid>
        {Array.from({ length: CARD_SKELETON_COUNT }).map((_, index) => (
          <ProgressCardSkeleton key={index} className="quizCardSectionSet">
            <Skeleton active title={{ width: "60%" }} paragraph={{ rows: 2 }} />
            <Skeleton.Avatar
              active
              size={96}
              shape="circle"
              style={{ margin: "12px auto 0", display: "block" }}
            />
          </ProgressCardSkeleton>
        ))}
      </CardsGrid>
    </Col>
  </Row>
);

export default StudentVisualsSkeleton;
